import React from "react";

const LoadingMessage = () => {
  return <h4>Loading...</h4>;
};

export default LoadingMessage;
